/**
 * Created by Dell on 18-01-2021.
 */
import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Redirect} from 'react-router-dom';

class Page403 extends Component {

    render() {
        return (
            <div className="wrapper wrapper-content" style={{padding: "10px 0px 10px 0px"}}>
                {
                    (0 === this.props.jwtToken.length && window.location.href.indexOf("resetPassword") <=0 ) ? (<Redirect to='/login'/>) : null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Forbidden</h5>
                            </div>
                            <div className="ibox-content table-responsive" style={{minHeight:"360px"}}>
                                <div className="middle-box text-center animated fadeInDown" style={{marginTop:'20px'}}>
                                    <h2 className="font-bold">403 Forbidden</h2>
                                    {/*<h3 className="font-bold">Page not found</h3>*/}

                                    <div className="error-desc">
                                        You don't have permission to access / on this  server <br/>
                                        <br/>
                                        <Link to={'/'} className="btn-sm btn-primary"  style={{color: 'white', fontSize:"13px"}} >
                                            Go to Dashboard</Link>&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Page403;


// WEBPACK FOOTER //
// ./src/components/errorsPage/403.js